import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
export function PricingSection() {
  return <section id="compra" className="w-full px-4 py-10 md:py-16 bg-gradient-to-b from-[#050810] to-[#0a0f1a]" data-id="element-53">
      <div className="max-w-3xl mx-auto" data-id="element-54">
        <div className="bg-[#050810] border-2 border-[#D4A843] rounded-2xl p-6 md:p-10 shadow-2xl" data-id="element-55">
          <h3 className="text-2xl md:text-3xl font-bold text-white mb-6 text-center" data-id="element-56">
            LIBERACIÓN MIOFASCIAL PRO
          </h3>

          <div className="mb-6" data-id="element-57">
            <ul className="space-y-3" data-id="element-58">
              <li className="flex items-start gap-3" data-id="element-59">
                <CheckIcon className="w-5 h-5 text-[#D4A843] flex-shrink-0 mt-0.5" data-id="element-60" />
                <span className="text-base text-gray-300" data-id="element-61">
                  Sistema completo de liberación miofascial
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-62">
                <CheckIcon className="w-5 h-5 text-[#D4A843] flex-shrink-0 mt-0.5" data-id="element-63" />
                <span className="text-base text-gray-300" data-id="element-64">
                  Protocolos de evaluación y tratamiento
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-65">
                <CheckIcon className="w-5 h-5 text-[#D4A843] flex-shrink-0 mt-0.5" data-id="element-66" />
                <span className="text-base text-gray-300" data-id="element-67">
                  Técnicas paso a paso
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-68">
                <CheckIcon className="w-5 h-5 text-[#D4A843] flex-shrink-0 mt-0.5" data-id="element-69" />
                <span className="text-base text-gray-300" data-id="element-70">
                  Casos reales y aplicaciones prácticas
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-71">
                <CheckIcon className="w-5 h-5 text-[#D4A843] flex-shrink-0 mt-0.5" data-id="element-72" />
                <span className="text-base text-gray-300" data-id="element-73">
                  + 3 BONOS EXCLUSIVOS GRATIS
                </span>
              </li>
            </ul>
          </div>

          <div className="text-center mb-6" data-id="element-74">
            <div className="mb-2" data-id="element-75">
              <span className="text-xl text-gray-400 line-through" data-id="element-76">
                $49.990
              </span>
            </div>
            <div className="mb-1" data-id="element-77">
              <span className="text-xs md:text-sm text-gray-400 uppercase tracking-wide" data-id="element-78">
                Precio especial hoy:
              </span>
            </div>
            <div className="text-4xl md:text-5xl font-bold text-[#D4A843]" data-id="element-79">
              $19.990
            </div>
          </div>

          <motion.a href="https://checkout.abastecedordigital.shop/cart/51761111400768:1" whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} className="block w-full bg-[#D4A843] hover:bg-[#c49a3a] text-[#0a0f1a] font-bold text-lg md:text-xl px-8 py-5 rounded-lg shadow-lg transition-all duration-300 hover:shadow-2xl text-center" data-id="element-80">
            🚀 QUIERO ACCEDER AHORA
          </motion.a>

          <p className="text-center text-gray-400 text-xs mt-4" data-id="element-81">
            Acceso inmediato • Pago seguro
          </p>
        </div>
      </div>
    </section>;
}